/* Elektrik 10.10.2026: wlasne podpowiedzi wyszukiwarki (zamiast modala Horizon z kafelkami).
 * Lewa kolumna: ostatnio szukane, frazy, kategorie, marki - ze slownika assets/elektrik-search-index.json
 *   (budowany przez scripts/elektrik_search_index.py; ladowany przy pierwszym kliknieciu w pole).
 *   Dopasowanie ignoruje polskie znaki (normEl), wyswietlanie zawsze z polskimi literami.
 * Prawa kolumna: produkty z /search?type=product&view=elsug (templates/search.elsug.liquid: wariant, indeks,
 *   EAN, cena, stan). Dla niedokonczonego slowa szukamy najlepszej frazy ze slownika ("pompa c" -> "pompa ciepła").
 * Komputer >= 990 px: panel pod polem w naglowku. Ponizej: pelny ekran po kliknieciu natywnej lupki.
 * Koszyk: /cart/add.js + zdarzenie CartLinesUpdateEvent (@shopify/events), zeby Horizon odswiezyl i otworzyl
 *   wysuwany koszyk (sam fetch zostawial w nim stara zawartosc). */
const CFG = window.ElektrikSearch || {};
const RECENT_KEY = 'el_ss_recent';
const isMob = () => window.innerWidth < 990;
const fmt = new Intl.NumberFormat('pl-PL');
const money = (c) => (c / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
const plural = (n, one, few, many) => { const r10 = n % 10, r100 = n % 100; return n === 1 ? one : (r10 >= 2 && r10 <= 4 && (r100 < 12 || r100 > 14)) ? few : many; };
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

export function normEl(s) {
  return (s || '').toLowerCase().replace(/ł/g, 'l').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ').trim();
}
function commonPrefix(a, b) { let i = 0; while (i < a.length && i < b.length && a[i] === b[i]) i++; return i; }
/* slowo zapytania pasuje do slowa w nazwie: poczatek albo wspolny rdzen (pompa/pompy, wylacznik/wylaczniki) */
function tokMatch(q, w) {
  if (w.startsWith(q)) return true;
  if (q.length >= 4) { const cp = commonPrefix(q, w); return cp >= 4 && cp >= q.length - 1; }
  return false;
}

/* ---------- slownik ---------- */
let IDX = null, idxPromise = null;
function loadIndex() {
  if (!idxPromise) {
    idxPromise = fetch(CFG.index, { credentials: 'omit' }).then((r) => r.json()).then((d) => {
      IDX = {
        p: (d.p || []).map(([t, c]) => { const n = normEl(t); return { t, c, n, w: n.split(' ') }; }),
        c: (d.c || []).map(([t, path, u, c]) => { const n = normEl(t); return { t, path, u, c, n, w: n.split(' ') }; }),
        b: (d.b || []).map(([t, c]) => { const n = normEl(t); return { t, c, n, nc: n.replace(/ /g, '') }; }),
      };
      return IDX;
    }).catch(() => (IDX = { p: [], c: [], b: [] }));
  }
  return idxPromise;
}
function matchPhrases(qn, limit) {
  if (!IDX || !qn) return [];
  const qt = qn.split(' '), out = [];
  for (const p of IDX.p) {
    let s = 0;
    if (p.n.startsWith(qn)) s = p.c * 4;
    else if (qt.every((q) => p.w.some((w) => w.startsWith(q)))) s = p.c;
    if (s) out.push([s, p]);
  }
  out.sort((a, b) => b[0] - a[0]);
  return out.slice(0, limit).map((x) => x[1]);
}
function matchCats(qn, limit) {
  if (!IDX || !qn) return [];
  const qt = qn.split(' ').filter((q) => q.length > 0), out = [];
  for (const c of IDX.c) {
    if (qt.every((q) => c.w.some((w) => tokMatch(q, w)))) out.push([c.c * (tokMatch(qt[0], c.w[0]) ? 3 : 1), c]);
  }
  out.sort((a, b) => b[0] - a[0]);
  return out.slice(0, limit).map((x) => x[1]);
}
function matchBrands(qn, limit) {
  if (!IDX || qn.length < 2) return [];
  const qc = qn.replace(/ /g, ''), out = [];
  for (const b of IDX.b) {
    if (b.nc.startsWith(qc)) out.push([b.c * 3, b]);
    else if (qc.length >= 3 && b.nc.includes(qc)) out.push([b.c, b]);
  }
  out.sort((a, b) => b[0] - a[0]);
  return out.slice(0, limit).map((x) => x[1]);
}
/* fraza do wyszukania produktow: "pompa c" -> "pompa ciepła"; kody i pelne slowa bez zmian */
function productQuery(raw, phrases, brands) {
  const qn = normEl(raw);
  if (!qn) return '';
  if (/\d/.test(qn) && !/\s/.test(raw.trim())) return raw.trim();
  const qt = qn.split(' '), last = qt[qt.length - 1];
  const best = phrases.find((p) => p.n.startsWith(qn));
  const lastIsWord = IDX && IDX.p.some((p) => p.w.length === 1 && p.n === last);
  if (best && !lastIsWord && !/\s$/.test(raw)) return best.t;
  if (!best && brands.length && brands[0].nc.startsWith(qn.replace(/ /g, '')) && qt.length === 1) return brands[0].t;
  return raw.trim();
}

/* ---------- ostatnio szukane ---------- */
function recentGet() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').filter(Boolean).slice(0, 8); } catch (e) { return []; } }
function recentSave(q) {
  q = (q || '').trim(); if (!q) return;
  try { const a = recentGet().filter((x) => normEl(x) !== normEl(q)); a.unshift(q); localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 8))); } catch (e) {}
}
function recentDel(q) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(recentGet().filter((x) => x !== q))); } catch (e) {} }

/* ---------- produkty ---------- */
const cache = new Map();
let ctrl = null;
function fetchProducts(q) {
  if (cache.has(q)) return Promise.resolve(cache.get(q));
  if (ctrl) ctrl.abort();
  ctrl = new AbortController();
  const url = `${CFG.searchUrl || '/search'}?q=${encodeURIComponent(q)}&type=product&view=elsug`;
  return fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
    .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then((d) => { cache.set(q, d); if (cache.size > 60) cache.delete(cache.keys().next().value); return d; });
}

/* ---------- koszyk ---------- */
async function addToCart(variantId, qty, origin) {
  let ev = null;
  try { ev = await import('@shopify/events'); } catch (e) { ev = null; }
  const LUE = ev && ev.CartLinesUpdateEvent;
  let deferred = null;
  if (LUE && typeof LUE.createPromise === 'function') {
    deferred = LUE.createPromise();
    origin.dispatchEvent(new LUE({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity: qty }], promise: deferred.promise }));
  }
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const fd = new FormData();
  fd.append('id', variantId); fd.append('quantity', qty);
  if (ids.length) fd.append('sections', ids.join(','));
  let res, cart;
  try {
    res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }).then((r) => r.json());
    cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  } catch (err) {
    if (deferred) deferred.reject(err);
    throw err;
  }
  const failed = !!res.status;
  if (deferred) {
    deferred.resolve({
      cart: LUE.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'elektrik-search', sourceId: 'el-ss', itemCount: qty, sections: failed ? undefined : res.sections, didError: failed },
    });
  } else {
    document.querySelectorAll('[class*="cart-bubble__text"], [class*="cart-count"]').forEach((el) => { el.textContent = String(cart.item_count); });
  }
  if (failed) throw res;
  return cart;
}

/* ---------- widok ---------- */
const ICON_SEARCH = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
const ICON_CLOCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
const ICON_FOLDER = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 7h6l2 2h10v10H3z"/></svg>';

function hl(t, qn) {
  /* fraza ma 1:1 litery po normalizacji (tylko litery, cyfry, pojedyncze spacje) - pogrubiamy dopowiedzenie */
  if (qn && normEl(t).startsWith(qn) && normEl(t).length === t.length) return `<span>${esc(t.slice(0, qn.length))}</span><b>${esc(t.slice(qn.length))}</b>`;
  return `<b>${esc(t)}</b>`;
}
function searchHref(q) { return `${CFG.searchUrl || '/search'}?q=${encodeURIComponent(q)}&type=product`; }

class ElSearch {
  constructor(form) {
    this.form = form;
    this.input = form.querySelector('input[name="q"]');
    this.q = '';
    this.active = -1;
    this.timer = 0;
    this.build();
    this.bind();
  }
  build() {
    const el = document.createElement('div');
    el.className = 'el-ss';
    el.hidden = true;
    el.innerHTML = `
      <div class="el-ss__backdrop" data-close></div>
      <div class="el-ss__panel" role="dialog" aria-modal="false" aria-label="Podpowiedzi wyszukiwania">
        <div class="el-ss__mhead">
          <button type="button" data-close aria-label="Zamknij wyszukiwanie"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg></button>
          <form action="${esc(CFG.searchUrl || '/search')}" method="get" role="search">
            <input type="hidden" name="type" value="product">
            <input type="search" name="q" class="el-ss__minput" placeholder="Nazwa, indeks, kod producenta lub EAN" autocomplete="off" enterkeyhint="search" aria-label="Szukaj produktu">
            <button type="button" class="el-ss__mclear" aria-label="Wyczyść" hidden><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg></button>
          </form>
        </div>
        <div class="el-ss__body">
          <div class="el-ss__left">
            <section class="el-ss__sec el-ss__sec--recent" hidden><h3>Ostatnio szukane</h3><ul class="el-ss__list"></ul><button type="button" class="el-ss__clear-recent">Wyczyść historię</button></section>
            <section class="el-ss__sec el-ss__sec--phrases" hidden><h3>Frazy</h3><ul class="el-ss__list"></ul></section>
            <section class="el-ss__sec el-ss__sec--cats el-ss__sec--chips" hidden><h3>Kategorie</h3><ul class="el-ss__list"></ul></section>
            <section class="el-ss__sec el-ss__sec--brands el-ss__sec--chips" hidden><h3>Marki</h3><ul class="el-ss__list"></ul></section>
          </div>
          <div class="el-ss__right">
            <div class="el-ss__exact" hidden><h3>Dokładne trafienie</h3><div class="el-ss__exactrow"></div></div>
            <h3 class="el-ss__phead">Produkty <small class="el-ss__pmode"></small></h3>
            <ul class="el-ss__prods"></ul>
            <a class="el-ss__all" data-nav hidden></a>
          </div>
        </div>
      </div>`;
    document.body.appendChild(el);
    this.el = el;
    this.panel = el.querySelector('.el-ss__panel');
    this.minput = el.querySelector('.el-ss__minput');
    this.mclear = el.querySelector('.el-ss__mclear');
    this.secRecent = el.querySelector('.el-ss__sec--recent');
    this.secPhr = el.querySelector('.el-ss__sec--phrases');
    this.secCat = el.querySelector('.el-ss__sec--cats');
    this.secBr = el.querySelector('.el-ss__sec--brands');
    this.exact = el.querySelector('.el-ss__exact');
    this.prods = el.querySelector('.el-ss__prods');
    this.phead = el.querySelector('.el-ss__phead');
    this.all = el.querySelector('.el-ss__all');
  }
  get field() { return isMob() ? this.minput : this.input; }
  bind() {
    const onFocus = () => this.open();
    this.input.addEventListener('focus', onFocus);
    this.input.addEventListener('click', onFocus);
    for (const inp of [this.input, this.minput]) {
      inp.addEventListener('input', () => { if (inp === this.minput) this.mclear.hidden = !inp.value; this.update(inp.value); });
      inp.addEventListener('keydown', (e) => this.onKey(e));
    }
    this.form.addEventListener('submit', (e) => { if (!this.input.value.trim()) { e.preventDefault(); return; } recentSave(this.input.value); });
    this.minput.form.addEventListener('submit', (e) => { if (!this.minput.value.trim()) { e.preventDefault(); return; } recentSave(this.minput.value); });
    this.mclear.addEventListener('click', () => { this.minput.value = ''; this.mclear.hidden = true; this.update(''); this.minput.focus(); });
    this.el.addEventListener('click', (e) => this.onClick(e));
    document.addEventListener('pointerdown', (e) => {
      if (this.el.hidden || isMob()) return;
      if (this.panel.contains(e.target) || this.form.contains(e.target)) return;
      this.close();
    }, true);
    /* natywna lupka motywu (telefon/tablet) otwiera nasz pelny ekran zamiast modala Horizon.
       Nasluch na window w fazie capture: deklaratywne on:click Horizona siedzi na document i odpalaloby sie pierwsze. */
    window.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('search-button button, [on\\:click="#search-modal/showDialog"]');
      if (!b || !isMob()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      this.open();
    }, true);
    const pos = () => { if (!this.el.hidden) this.place(); };
    window.addEventListener('resize', pos);
    document.addEventListener('scroll', pos, { capture: true, passive: true });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.el.hidden) { this.close(); if (!isMob()) this.input.blur(); } });
  }
  place() {
    if (isMob()) return;
    const r = this.form.getBoundingClientRect();
    const pad = Math.max(40, (window.innerWidth - 1440) / 2);
    this.el.style.setProperty('--ss-top', `${Math.round(r.bottom + 8)}px`);
    this.el.style.setProperty('--ss-left', `${Math.round(pad)}px`);
    this.el.style.setProperty('--ss-width', `${Math.round(window.innerWidth - 2 * pad)}px`);
  }
  open() {
    loadIndex().then(() => { if (!this.el.hidden) this.update(this.field.value, true); });
    if (!this.el.hidden) return;
    this.el.hidden = false;
    this.place();
    if (isMob()) {
      document.documentElement.classList.add('el-ss-lock');
      this.minput.value = this.input.value || this.minput.value;
      this.mclear.hidden = !this.minput.value;
      setTimeout(() => this.minput.focus(), 30);
    }
    this.update(this.field.value, true);
  }
  close() {
    this.el.hidden = true;
    this.active = -1;
    document.documentElement.classList.remove('el-ss-lock');
  }
  update(raw, force) {
    if (!force && raw === this.q) return;
    this.q = raw;
    this.active = -1;
    const qn = normEl(raw);
    const mob = isMob();
    /* ostatnio szukane: przy pustym polu wszystkie, przy wpisywaniu pasujace (max 3) */
    let rec = recentGet();
    if (qn) rec = rec.filter((r) => normEl(r).includes(qn) && normEl(r) !== qn).slice(0, 3);
    this.renderList(this.secRecent, rec.map((r) => `<li><a class="el-ss__item el-ss__recent" data-nav data-q="${esc(r)}" href="${searchHref(r)}">${ICON_CLOCK}<span class="el-ss__txt">${esc(r)}</span><button type="button" class="el-ss__del" data-del="${esc(r)}" aria-label="Usuń z historii">×</button></a></li>`));
    this.secRecent.querySelector('.el-ss__clear-recent').hidden = !!qn || !rec.length;

    if (!qn) {
      this.renderList(this.secPhr, []);
      this.secPhr.hidden = true;
      const pop = this.popularCats();
      this.secCat.querySelector('h3').textContent = 'Popularne kategorie';
      this.renderList(this.secCat, pop.map((c) => this.catItem(c)));
      this.renderList(this.secBr, []);
      this.renderHint();
      return;
    }
    this.secCat.querySelector('h3').textContent = 'Kategorie';
    const qa = qn.split(' ').filter((w) => !/\d/.test(w)).join(' ');
    let phrases = matchPhrases(qn, mob ? 5 : 7);
    if (!phrases.length && qa && qa !== qn) phrases = matchPhrases(qa, mob ? 5 : 7);
    const brands = matchBrands(qn, mob ? 8 : 4);
    const pq = productQuery(raw, phrases, brands);
    /* kategorie: najpierw dla dopowiedzianej frazy ("pompa c" -> "pompa ciepła"), potem dla wpisanego tekstu */
    const pqn = normEl(pq);
    let cats = pqn && pqn !== qn ? matchCats(pqn, mob ? 8 : 5) : [];
    if (!cats.length) cats = matchCats(qn, mob ? 8 : 5);
    if (!cats.length && qa && qa !== qn) cats = matchCats(qa, mob ? 8 : 5);
    this.renderList(this.secPhr, phrases.map((p) => `<li><a class="el-ss__item el-ss__phrase" data-nav data-q="${esc(p.t)}" href="${searchHref(p.t)}">${ICON_SEARCH}<span class="el-ss__txt">${hl(p.t, qn)}</span><small>${fmt.format(p.c)}</small></a></li>`));
    this.renderList(this.secCat, cats.map((c) => this.catItem(c)));
    this.renderList(this.secBr, brands.map((b) => `<li><a class="el-ss__item el-ss__brand" data-nav href="/collections/vendors?q=${encodeURIComponent(b.t)}"><span class="el-ss__txt">${esc(b.t)}</span><small>${fmt.format(b.c)}</small></a></li>`));

    clearTimeout(this.timer);
    this.prods.classList.add('is-loading');
    this.timer = setTimeout(() => this.loadProducts(raw, pq), cache.has(pq) ? 0 : 220);
  }
  popularCats() {
    if (!IDX) return [];
    const want = CFG.popular || [];
    const out = [];
    for (const t of want) { const n = normEl(t); const c = IDX.c.filter((x) => x.n === n).sort((x, y) => y.c - x.c)[0]; if (c && !out.includes(c)) out.push(c); }
    if (out.length < 6) for (const c of [...IDX.c].sort((a, b) => b.c - a.c)) { if (out.length >= 8) break; if (!out.includes(c)) out.push(c); }
    return out.slice(0, 8);
  }
  catItem(c) {
    return `<li><a class="el-ss__item el-ss__cat" data-nav href="${esc(c.u)}">${ICON_FOLDER}<span class="el-ss__txt">${esc(c.t)}${c.path ? `<span class="el-ss__path">${esc(c.path)}</span>` : ''}</span><small>${fmt.format(c.c)}</small></a></li>`;
  }
  renderList(sec, items) {
    sec.querySelector('.el-ss__list').innerHTML = items.join('');
    sec.hidden = !items.length;
  }
  renderHint() {
    clearTimeout(this.timer);
    this.exact.hidden = true;
    this.all.hidden = true;
    this.phead.hidden = true;
    this.prods.classList.remove('is-loading');
    const ex = ['CIG573', 'wyłącznik B16', 'pompa ciepła', 'przewód YDY 3x2,5', 'Eaton'];
    this.prods.innerHTML = `<li class="el-ss__hint">Wpisz <b>nazwę produktu</b>, <b>indeks</b>, <b>kod producenta</b> albo <b>EAN</b>. Polskie znaki nie są wymagane.
      <div class="el-ss__ex">${ex.map((x) => `<a class="el-ss__chip" data-nav data-q="${esc(x)}" href="${searchHref(x)}">${esc(x)}</a>`).join('')}</div></li>`;
  }
  loadProducts(raw, pq) {
    if (raw !== this.q) return;
    fetchProducts(pq).then((d) => {
      if (raw !== this.q) return;
      this.renderProducts(raw, pq, d);
    }).catch((e) => {
      if (e && e.name === 'AbortError') return;
      this.prods.classList.remove('is-loading');
      this.prods.innerHTML = `<li class="el-ss__empty">Nie udało się pobrać produktów. Naciśnij Enter, żeby zobaczyć wyniki wyszukiwania.</li>`;
    });
  }
  renderProducts(raw, pq, d) {
    this.prods.classList.remove('is-loading');
    this.phead.hidden = false;
    this.phead.querySelector('.el-ss__pmode').textContent = document.documentElement.classList.contains('el-netto') ? 'ceny netto' : 'ceny brutto';
    let list = (d && d.p) || [];
    const code = raw.trim().toUpperCase();
    let exact = null;
    if (code.length >= 4 && !/\s/.test(code)) exact = list.find((p) => (p.s && p.s.toUpperCase() === code) || (p.e && String(p.e) === code));
    if (exact) {
      this.exact.hidden = false;
      this.exact.querySelector('.el-ss__exactrow').innerHTML = `<ul class="el-ss__prods">${this.prodRow(exact)}</ul>`;
      list = list.filter((p) => p !== exact);
    } else this.exact.hidden = true;
    const n = (d && d.n) || 0;
    this.phead.hidden = !list.length && !!exact;
    if (!list.length && !exact) {
      this.prods.innerHTML = `<li class="el-ss__empty">Brak produktów dla „${esc(raw.trim())}”. Sprawdź pisownię albo wpisz indeks lub kod producenta. Nie mamy tego w katalogu? <a href="/pages/kontakt?temat=wycena">Napisz do nas</a>, sprowadzimy na zamówienie.</li>`;
    } else {
      this.prods.innerHTML = list.slice(0, isMob() ? 6 : 8).map((p) => this.prodRow(p)).join('');
    }
    const label = pq || raw.trim();
    this.all.hidden = !n;
    this.all.href = searchHref(label);
    this.all.dataset.q = label;
    this.all.innerHTML = `<span>Pokaż wszystkie wyniki dla „${esc(label)}”</span><small>${n >= 1000 ? 'ponad 1 000 produktów' : `${fmt.format(n)} ${plural(n, 'produkt', 'produkty', 'produktów')}`} →</small>`;
  }
  prodRow(p) {
    const vat = p.v8 ? 1.08 : 1.23;
    const net = Math.round(p.g / vat);
    const av = p.a ? `<span class="el-ss__av is-ok">${p.q > 0 ? `Od ręki: ${fmt.format(p.q)} szt.` : 'Dostępny'}</span>` : '<span class="el-ss__av">Na zamówienie</span>';
    const img = p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy" width="56" height="56">` : '';
    const buy = p.a
      ? `<span class="el-ss__qty"><button type="button" data-step="-1" aria-label="Mniej">−</button><input type="text" inputmode="numeric" value="1" aria-label="Ilość"><button type="button" data-step="1" aria-label="Więcej">+</button></span><button type="button" class="el-ss__add" data-variant="${esc(p.v)}">Do koszyka</button>`
      : `<a class="el-ss__ask" href="${esc(p.u)}">Zapytaj</a>`;
    return `<li class="el-ss__prod" data-nav data-href="${esc(p.u)}">
      <a class="el-ss__pimg" href="${esc(p.u)}" tabindex="-1">${img}</a>
      <div class="el-ss__pmain"><a class="el-ss__pt" href="${esc(p.u)}">${esc(p.t)}</a>
        <div class="el-ss__pmeta">${p.b ? `<span>${esc(p.b)}</span>` : ''}${p.s ? `<span class="el-ss__sku">Indeks: ${esc(p.s)}</span>` : ''}${av}</div></div>
      <div class="el-ss__pprice"><span class="el-ss__gross"><b>${money(p.g)}</b> <small>brutto</small></span><span class="el-ss__net"><b>${money(net)}</b> <small>netto</small></span></div>
      <div class="el-ss__pbuy">${buy}</div>
    </li>`;
  }
  navItems() { return [...this.el.querySelectorAll('[data-nav]')].filter((x) => x.offsetParent !== null); }
  onKey(e) {
    if (this.el.hidden) { if (e.key === 'ArrowDown') this.open(); return; }
    const items = this.navItems();
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (!items.length) return;
      /* -1 = kursor w polu tekstowym; strzalki przechodza po wszystkich pozycjach i wracaja do pola */
      const d = e.key === 'ArrowDown' ? 1 : -1;
      const n = items.length + 1;
      this.active = ((this.active + 1 + d + n) % n) - 1;
      items.forEach((x, i) => x.classList.toggle('is-active', i === this.active));
      const cur = items[this.active];
      if (cur) cur.scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter') {
      const cur = items[this.active];
      if (cur) { e.preventDefault(); this.go(cur); }
    }
  }
  go(item) {
    const q = item.dataset.q;
    if (q) recentSave(q);
    else if (this.field.value.trim()) recentSave(this.field.value);
    const href = item.dataset.href || item.getAttribute('href');
    if (href) window.location.href = href;
  }
  onClick(e) {
    const t = e.target;
    if (t.closest('[data-close]')) { this.close(); return; }
    const del = t.closest('.el-ss__del');
    if (del) { e.preventDefault(); e.stopPropagation(); recentDel(del.dataset.del); this.update(this.field.value, true); return; }
    if (t.closest('.el-ss__clear-recent')) { try { localStorage.removeItem(RECENT_KEY); } catch (err) {} this.update(this.field.value, true); return; }
    const step = t.closest('[data-step]');
    if (step) {
      const inp = step.parentElement.querySelector('input');
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(step.dataset.step, 10));
      return;
    }
    if (t.closest('.el-ss__qty')) return;
    const add = t.closest('.el-ss__add');
    if (add) { this.onAdd(add); return; }
    const a = t.closest('a[href]');
    if (a) {
      const q = a.dataset.q;
      if (q) recentSave(q);
      else if (this.field.value.trim() && (a.closest('.el-ss__prod') || a.classList.contains('el-ss__cat') || a.classList.contains('el-ss__brand'))) recentSave(this.field.value);
      return;
    }
    const row = t.closest('.el-ss__prod');
    if (row && row.dataset.href) { this.go(row); }
  }
  onAdd(btn) {
    if (btn.disabled) return;
    const row = btn.closest('.el-ss__prod');
    const qi = row.querySelector('.el-ss__qty input');
    const qty = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    btn.disabled = true;
    btn.textContent = 'Dodaję…';
    addToCart(btn.dataset.variant, qty, this.panel).then(() => {
      btn.textContent = 'Dodano ✓';
      if (this.field.value.trim()) recentSave(this.field.value);
      setTimeout(() => { btn.disabled = false; btn.textContent = 'Do koszyka'; }, 1800);
      setTimeout(() => this.close(), 350);
    }).catch((err) => {
      const d = (err && (err.description || err.message)) || '';
      btn.textContent = /stock|zapas|available|dostęp|sold out/i.test(d) ? 'Za mało sztuk' : 'Nie udało się';
      setTimeout(() => { btn.disabled = false; btn.textContent = 'Do koszyka'; }, 2200);
    });
  }
}

function init() {
  const form = document.querySelector('form.el-a-search');
  if (!form || form.dataset.elSs) return;
  form.dataset.elSs = '1';
  window.elektrikSearch = new ElSearch(form);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
